import React, { Component, Fragment } from 'react';
import Table from './PagePathTable/index';
import { csvColumns, tableColumns } from './constants';
import cx from 'classnames';
import styles from './styles.scss';
import ModuleExport from '../../ModuleExport';
import PagePathChart from './PagePathChart';
import {
  shape,
  string,
  arrayOf,
  number,
  bool,
  func,
  objectOf,
} from 'prop-types';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import { get, orderBy } from 'lodash';
import { FormControl, MenuItem, Select, withStyles } from '@material-ui/core';
import DeleteReportItemButton from '../../DeleteReportItem';
import { connect } from 'react-redux';
import {
  COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  MIN_LENGTH_PAGE_PATH_DATA,
  PAGE_PATH_CHART_ID,
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  LIMIT_CHART_DATA,
} from '../../../helpers/constant';
import { getNumberOfChartAndTableInReport } from '../Report/helper';

const defaultDataType = get(defaultChartSelector, [PAGE_PATH_CHART_ID, 'type']);

export class PagePathAnalytics extends Component {
  static propTypes = {
    title: string,
    fileName: string,
    inpdf: bool,
    dropDownOptions: shape({
      label: string,
      value: string
    }),
    selectionType: string,
    setChartSelector: func,
    isCustomize: string,
    page: number,
    pageNumber: number,
    data: arrayOf(shape({
      pagePathType: string,
      ads: number,
      adVisit: number,
      adUser: number,
      totalVisits: number,
    })),
    isCustomReport: bool,
    currentStep: string,
    showInReportConfig: shape({
      pagePathChart: bool,
      pagePathTable: bool,
    }),
    countInReportConfig: shape({
      pagePathChart: arrayOf(number),
      pagePathTable: arrayOf(number),
    }),
    pagePathChartSelectors: arrayOf(objectOf(string)),
    tableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    campaign: shape({}),
    setReportChartSelector: func,
    classes: shape({}),
    totalAds: number,
    isHiddenChart: bool,
    isTableOnly: bool,
    rowOnFirstPage: number,
    isMeasuringSize: bool
  }

  static defaultProps = {
    title: 'Page Path',
    fileName: 'page_path_analytics_chart',
    dropDownOptions: {
      adVisits: {
        label: 'Ad Visits',
        key: 'adVisits'
      },
    },
    isCustomize: 'customize',
    showInReportConfig: {},
    countInReportConfig: {
      pagePathChart: [1],
      pagePathTable: [1],
    },
    data: []
  }

  state = { selectionType : 'adVisits'}

  handleTypeChange = (selectorIndex, chartId) => (e) => {
    const {
      setChartSelector,
      campaign,
      setReportChartSelector,
    } = this.props;
    const campaignId = campaign.campaign_id;
    const newType = e.target.value;
    setChartSelector && setChartSelector(
      campaignId,
      chartId,
      { type: newType }
    );
    setReportChartSelector && setReportChartSelector(chartId, selectorIndex, {
      type: newType });
  }

  
  handleSetChartSelector = (index, selectorObj) => {
    const { setChartSelector, campaign, setReportChartSelector } = this.props;
    const campaignId = campaign.campaign_id;
    setChartSelector && setChartSelector(campaignId, PAGE_PATH_CHART_ID, selectorObj);
    setReportChartSelector && setReportChartSelector(PAGE_PATH_CHART_ID, index, selectorObj);
  }

  drawDropDown(selectorIndex, reportTypeSelector, handleTypeChange) {
    const { dropDownOptions, classes, selectionType } = this.props;
    const dropDownOptionList = Object.values(dropDownOptions);

    return (
      <FormControl className={styles.dropDown}>
        <Select
          value={reportTypeSelector || selectionType}
          className={styles.selector}
          onChange={handleTypeChange(selectorIndex, PAGE_PATH_CHART_ID)}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
        >
          {
            dropDownOptionList.map(item => (
              <MenuItem
                value={item.key}
                key={item.key}
              >
                {item.label}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    );
  }
  
  prepChartData(pagePathChartSelectorType) {
    const { dropDownOptions, data, selectionType } = this.props;
    const chartSelectorType = pagePathChartSelectorType || selectionType;
    const { key, label } = get(dropDownOptions, [chartSelectorType], {});
    const newData = orderBy(data, [chartSelectorType], 'desc');
    const filterData = newData.slice(0, LIMIT_CHART_DATA);
    const chartData =  filterData.reduce((accum, entry) => {
      const { pagePathType :  y } = entry;
      const x = entry[key];
      if (x != undefined && y) {
        accum.push({ y, x });
      }
      return accum;
    }, []);
    return { chartData, valueLabel: label, valueKey: key };
  }

  exportContainer = React.createRef();
  render() {
    const {
      title,
      fileName,
      data,
      currentStep, 
      isCustomReport,
      countInReportConfig,
      showInReportConfig,
      inpdf,
      pagePathChartSelectors,
      page,
      pageNumber,
      isCustomize,
      tableSortSelector,
      totalAds,
      isHiddenChart,
      rowOnFirstPage,
      isMeasuringSize
    } = this.props;

    const { chartData, valueLabel } = this.prepChartData();
    const { pagePathChart, pagePathTable } = showInReportConfig;
    const {
      pagePathChart: chartCount,
      pagePathTable: tableCount,
    } = countInReportConfig;
    const pagePathChartAndTableCount = (!isHiddenChart && inpdf) ? isMeasuringSize ? 2 : 1 : getNumberOfChartAndTableInReport(chartCount, tableCount);
    const isGrandTotalDisplay = !inpdf || inpdf && page === pageNumber - 1;
    const isFirstPDFPage = !inpdf || (inpdf && page === 0);

    let isDisplayChart = true;
    let isDisplayTable = true;
    let showDeleteChartButton = false;
    let showDeleteTableButton = false;
    if (isCustomReport) {
      isDisplayChart = pagePathChart && isFirstPDFPage;
      isDisplayTable = pagePathTable;
      showDeleteChartButton = pagePathChart;
      showDeleteTableButton = pagePathTable;
    }

    return(
      <div className={cx({[styles.pagePathAnalyticsMainView]: !isCustomReport}, styles.pagePathAnalyticsContainer)}>
        {Array(pagePathChartAndTableCount).fill('').map((_item, index) => {
            const prefixKey = chartCount[index] ? pagePathChartId : pagePathTableId;
            const key = chartCount[index] || tableCount[index] || (index + 1);
            const isDisplayChartInPreview = !!chartCount.find(item => item === index + 1) && (inpdf ? !isHiddenChart : true);
            isDisplayChart = !inpdf ? isDisplayChartInPreview && isFirstPDFPage : !isHiddenChart;
            isDisplayTable = !!tableCount.find(item => item === index + 1) &&(inpdf ? isHiddenChart : true);
            const reportTypeSelector = get(pagePathChartSelectors, [index, 'type']);
            const reportData = this.prepChartData(reportTypeSelector);
            const reportChartData  = get(reportData, 'chartData');
            const reportValueLabel = get(reportData, 'valueLabel');
            const isDisplayChartContainer = !inpdf && (isDisplayChart || isDisplayTable) || inpdf && isDisplayChart;
            showDeleteChartButton = isCustomReport && isDisplayChart;
            const rowFirstPageInPdf = rowOnFirstPage || MIN_LENGTH_PAGE_PATH_DATA;
            let rowsPerPagePathPage = inpdf
            ? page === 0
              ? (rowFirstPageInPdf + 1)
              : 25
            : 0;

            return (
              <Fragment key={prefixKey + key}>
                {isDisplayChartContainer && (
                  <Fragment>
                    {isDisplayChart && (
                      <ModuleExport
                        exportImg={this.exportContainer}
                        fileName={fileName}
                        disableCsvExport
                      />
                    )}
                    <div
                      ref={this.exportContainer}
                      className={cx(
                        {
                          [styles.deleteItemContainer]:
                            currentStep === isCustomize && isDisplayChart
                        },
                        styles.itemContainer
                      )}
                    >
                      {showDeleteChartButton && (
                        <DeleteReportItemButton
                          isDelete={showDeleteChartButton}
                          parentId={pagePathId}
                          componentId={pagePathChartId}
                          customClassName={styles.deleteButton}
                          itemIndex={index}
                        />
                      )}
                      {!inpdf && (
                        <div className={styles.header}>
                          <div>{title}</div>
                        </div>
                      )}
                      <div className={styles.containerDropdown}>
                        {this.drawDropDown(index, reportTypeSelector, this.handleTypeChange)}
                      </div>

                      {isDisplayChart && (
                        <div className={styles.contentContainer}>
                          <div className={styles.chartContainer}>
                            <div className={styles.chart} data-test="pagePathChart">
                              <PagePathChart
                                data={reportChartData || chartData}
                                xAxisTitle={reportValueLabel || valueLabel}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Fragment>
                )}
                {isDisplayTable && (
                  <div
                    className={cx(
                      {
                        [styles.deleteItemContainer]:
                          currentStep === isCustomize
                      },
                      styles.tableContainer,
                      styles.itemContainer
                    )}
                  >
                    {showDeleteTableButton && (
                      <DeleteReportItemButton
                        isDelete={showDeleteTableButton}
                        parentId={pagePathId}
                        componentId={pagePathTableId}
                        customClassName={styles.deleteButton}
                        itemIndex={index}
                      />
                    )}
                    <Table
                      data={data}
                      totalAds={totalAds}
                      page={page}
                      tableColumns={tableColumns}
                      isGrandTotalDisplay={isGrandTotalDisplay}
                      tableSortSelector={tableSortSelector}
                      csvColumns={csvColumns}
                      rowsPerPage={rowsPerPagePathPage}
                      numberPage={pageNumber}
                      inpdf={inpdf}
                      itemIndex={index}
                      isCustomReport={isCustomReport}
                      isDisplayChart={pagePathChart && (inpdf ? !isHiddenChart : true)}
                      rowsFirstPage={rowOnFirstPage}
                    />
                  </div>
                )}
              </Fragment>
            );
          })}
      </div>
    )
  }
};

const muiStyle = {
  arrowDropDown: {
    color: '#2196f3'
  }
};

import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';
import { setChartSelector } from '../../../state/modules/app/campaign';
import { pagePathChartId, pagePathId, pagePathTableId } from '../../../pages/ReportBuilder/constants';

const PagePathAnalyticsSmartComponent = connect(
  (state, props) => {
    const { chartData, campaign } = props;
    const totalAds = get(chartData, 'totalAds', 0);
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const data = get(chartData, [PAGE_PATH_CHART_ID, 'data'], []);
    const selectionType = get(campaign, ['chartSelector', PAGE_PATH_CHART_ID, 'type'], defaultDataType);
    const pagePathChartSelectors =  props.pagePathChartSelectors || get(state, ['reportBuilder', 'chartSelector', PAGE_PATH_CHART_ID], []);
    return {
      data,
      totalAds,
      currentStep,
      selectionType,
      pagePathChartSelectors
    }
  },
  {
    setReportChartSelector,
    setChartSelector,
  }
)(withStyles(muiStyle)(PagePathAnalytics));
export default PagePathAnalyticsSmartComponent;
